// Config of locales
import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./i18n/locale-en";
import de from "./i18n/locale-de";

Vue.use(VueI18n);

/**
 * Locale gets set by the store!
 */
export default new VueI18n({
  locale: "en",
  silentTranslationWarn: process.env.NODE_ENV === "production",
  // fallbackLocale: "de",
  messages: {
    en: {
      lang: en
    },
    de: {
      lang: de
    }
  }
});
